document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-beauty-pack-page]').forEach((page) => {
    const slides = [...page.querySelectorAll('[data-beauty-slide]')];
    const thumbs = [...page.querySelectorAll('[data-beauty-thumb]')];
    let current = 0;

    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
        thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      thumbs[current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    page.querySelector('[data-beauty-prev]')?.addEventListener('click', () => show(current - 1));
    page.querySelector('[data-beauty-next]')?.addEventListener('click', () => show(current + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));

    const mainButton = page.querySelector('[data-beauty-atc]');
    page.querySelector('[data-beauty-sticky-atc]')?.addEventListener('click', () => {
      mainButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      mainButton?.focus({ preventScroll: true });
    });

    show(0);
  });
});
